<template>
    <div>
      <div class="nav-link-list" style="width: 100%;">
        <ul
          class="title-list"
          style="width:70%;"
        >
          <li class="home-page">
            <router-link
              to="SecondaryPage"
            >首&nbsp;&nbsp;&nbsp;&nbsp;页</router-link>
          </li>
          <li v-if="([3].includes($store.state.auth.userInfo.roleId)) && !isSafeMgr">
            <router-link to="project-video" active-class="active" style="text-decoration: none;">视频监控</router-link>
          </li>
          <li v-if="!isSafeMgr">
            <router-link to="all-projects" active-class="active" style="text-decoration: none;">全 &nbsp;&nbsp;&nbsp;&nbsp;部</router-link>
          </li>
          <li v-if="$store.state.auth.userInfo.authList.indexOf('keyproject')>=0 && !isSafeMgr">
            <router-link to="key-projects" active-class="active" style="text-decoration: none;">重点任务</router-link>
          </li>
          <li v-if="$store.state.auth.userInfo.authList.indexOf('chanyeproject')>=0 && !isSafeMgr">
            <router-link to="industrial-development" active-class="active" style="text-decoration: none;">一般任务</router-link>
          </li>
          <li v-if="$store.state.auth.userInfo.authList.indexOf('dubanproject')>=0 && !isSafeMgr">
            <router-link to="fold-up-project" active-class="active" style="text-decoration: none;">特殊任务</router-link>
          </li>
          <li v-if="$store.state.auth.userInfo.authList.indexOf('temproject')>=0 && !isSafeMgr">
            <router-link to="Temporaryduty" active-class="active" style="text-decoration: none;">临时任务</router-link>
          </li>
          <li v-if="$store.state.auth.userInfo.authList.indexOf('fileproject')>=0 && !isSafeMgr">
            <router-link :to="{name:'documentsProjects',query:{id:'export'}}" active-class="active" style="text-decoration: none;">归&nbsp;&nbsp;&nbsp;&nbsp;档</router-link>
          </li>
          <li v-if="$store.state.auth.userInfo.authList.indexOf('pishiproject')>=0 && isSafeMgr">
            <router-link to="Safemgr" active-class="active" style="text-decoration: none;">安全管理</router-link>
          </li>
        </ul>
      </div>
    </div>
</template>

<script>
    export default {
      name: "index",
      props: [
        "itemType"
      ],
      data(){
          return{
            name:'',
            isSafeMgr: this.itemType=='11'?true:false,
          }

      },
      created(){
        this.name=this.$route.name
      },

    }
</script>

<style scoped lang="less">
  .active{
    display: inline-block;
    color: #ffffff;
    cursor: pointer;
    width: 140px;
    height: 50px;
    text-align: center;
    line-height: 50px;
    font-size: 24px;
    background-color: #217DC3 !important;
    background-image: linear-gradient(red,#217DC3);
    border-radius: 10px 10px 0 0;
  }
</style>
